import { motion } from 'framer-motion';
import Image from 'next/image';
import Link from 'next/link';
import React, { FC } from 'react';

import RenderIf from '@/components/Common/RenderIf';
import CategoryBadge from '@/components/Layout/Header/Search/Suggestions/Badge/Category';
import Top10 from '@/components/Layout/Header/Search/Suggestions/Badge/Top10';

import { Endpoints } from '@/network';
import { generateUrlForImage } from '@/pages/books/[bookId]';
import { Book as IBook } from '@/utils/interfaces/Library/Books';

interface Props {
  book: IBook;
  onClickBook?: () => void;
}

const Orange: FC<Props> = ({ book, onClickBook }) => {
  const imageUrl = book?.coverImageUrl?.startsWith('http')
    ? book.coverImageUrl
    : generateUrlForImage(
        `${process.env.NEXT_PUBLIC_API_READER_URL}/`,
        `${Endpoints.getCoverImagesForBooks}/`,
        `${book?._id}`,
      );

  const getInternalHref = () => {
    return `/oranges/${book.slug}-${book._id}/`;
  };

  const href =
    book.externalLink && !book.isExternalLink ? book.externalLink : getInternalHref();

  return (
    <motion.div
      key={book._id}
      layout
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
      className='relative sm:w-[127px] sm:min-w-[127px] w-[110px] min-w-[110px] aspect-[127/180] rounded overflow-hidden'
    >
      <Link
        onClick={(e) => {
          e.stopPropagation();
          onClickBook?.();
        }}
        href={href}
        className='relative sm:w-full sm:min-w-full w-full min-w-full'
      >
        <Image
          width={127}
          height={180}
          className='w-full h-full object-cover transition-all'
          src={imageUrl || '/placeholder.svg'}
          alt={book?.title || 'Orange Book'}
        />
      </Link>
      <CategoryBadge
        type='ORANGES'
        className='bg-gradient-to-b from-[#FF7A00] to-[#E54D00]'
      />
      <RenderIf condition={Boolean(book?.topRanking)}>
        <Top10 className='absolute right-0 top-0' />
      </RenderIf>
    </motion.div>
  );
};

export default Orange;
